// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./reset.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!./colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Source+Serif+4:ital,opsz,wght@0,8..60,200..900;1,8..60,200..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    --space-2xs: 4px;
    --space-xs: 8px;
    --space-sm: 16px;
    --space-md: 24px;
    --space-lg: 32px;
    --space-xl: 48px;
    --space-2xl: 64px;
    --space-3xl: 96px;
    --touch-target-min: 48px;
    --page-content-max-width: 1200px;

    --radius-sm: 6px;
    --radius-md: 10px;
    --radius-lg: 16px;

    --focus-outline-offset: 4px;
    --focus-outline-offset-sm: 2px;
}

html {
    font-size: 16px;
}

body,
:host {
    background: var(--color-neutral-50);
    color: var(--color-text-primary);
    font-family: 'Hanken Grotesk', 'Open Sans', sans-serif;
    font-size: 1rem;
    font-weight: 400;
}

p {
    margin-top: 0;
    margin-bottom: var(--space-sm);
    line-height: 1.6;
}

h1 {
    font-size: 38px;
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -0.015em;
    margin-top: 0;
    margin-bottom: var(--space-md);
}

h2 {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.01em;
    margin-top: 0;
    margin-bottom: var(--space-sm);
}

h3 {
    font-size: 22px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: -0.005em;
    margin-top: 0;
    margin-bottom: var(--space-sm);
}

h4 {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    margin-top: 0;
    margin-bottom: var(--space-xs);
}

h5 {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.35;
    margin-top: 0;
    margin-bottom: var(--space-xs);
}

.vec-text-display {
    font-size: 48px;
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -0.02em;
    margin-top: 0;
    margin-bottom: var(--space-lg);
}

@media (min-width: 1280px) {
    .vec-text-display {
        font-size: 64px;
    }
}

.vec-text-small {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
}

.vec-text-caption {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: 0.01em;
}

.vec-text-label {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

/* Visually hides content while keeping it in the accessibility tree — e.g. a heading needed
   for document structure/screen readers but not part of a page's visual design. */
.vec-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

a {
    color: var(--color-text-brand);
    text-decoration: underline;
}

a:focus-visible {
    outline: 2px solid var(--color-focus-outline);
    outline-offset: var(--focus-outline-offset);
    border-radius: var(--radius-sm);
}

/* Plain HTML tables only — excludes anything rendered inside antd's Table (\`.ant-table\`),
   which supplies its own styling and shouldn't be touched here. */
table:not(.ant-table table) {
    width: 100%;
    margin-bottom: var(--space-sm);
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--color-neutral-300);
    border-radius: var(--radius-md);
    overflow: hidden;
}

table:not(.ant-table table) th,
table:not(.ant-table table) td {
    padding: var(--space-xs) var(--space-sm);
    text-align: left;
    border-right: 1px solid var(--color-neutral-300);
    border-bottom: 1px solid var(--color-neutral-300);
}

table:not(.ant-table table) th:last-child,
table:not(.ant-table table) td:last-child {
    border-right: none;
}

table:not(.ant-table table) tr:last-child > td {
    border-bottom: none;
}

table:not(.ant-table table) th {
    background: var(--color-surface-brand);
    color: var(--color-text-on-brand);
    font-weight: 600;
}

/* Plain lists only — excludes anything rendered inside an antd component (Menu, Pagination,
   Rate, dropdown menus, etc. all render bare <ul>s of their own that shouldn't be touched here). */
ol:not([class*="ant-"] ol),
ul:not([class*="ant-"] ul) {
    margin: 0 0 var(--space-sm);
    padding-left: var(--space-md);
}

ol:not([class*="ant-"] ol) ol,
ul:not([class*="ant-"] ul) ul {
    margin-top: var(--space-2xs);
    margin-bottom: 0;
}

ol:not([class*="ant-"] ol) li,
ul:not([class*="ant-"] ul) li {
    margin-bottom: var(--space-2xs);
}

ol:not([class*="ant-"] ol) {
    list-style-type: decimal;
}

ol:not([class*="ant-"] ol) ol {
    list-style-type: lower-alpha;
}

ol:not([class*="ant-"] ol) ol ol {
    list-style-type: lower-roman;
}

ol:not([class*="ant-"] ol) li::marker {
    font-weight: 700;
}

ul:not([class*="ant-"] ul) {
    list-style-type: disc;
}

ul:not([class*="ant-"] ul) ul {
    list-style-type: circle;
}

ul:not([class*="ant-"] ul) ul ul {
    list-style-type: square;
}
`, "",{"version":3,"sources":["webpack://./vector/src/styles/base.css"],"names":[],"mappings":"AAIA;;IAEI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,gCAAgC;;IAEhC,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;IAEjB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,mCAAmC;IACnC,gCAAgC;IAChC,sDAAsD;IACtD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;kFACkF;AAClF;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,6CAA6C;IAC7C,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;kEACkE;AAClE;IACI,WAAW;IACX,8BAA8B;IAC9B,yBAAyB;IACzB,iBAAiB;IACjB,0CAA0C;IAC1C,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;;IAEI,wCAAwC;IACxC,gBAAgB;IAChB,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;mGACmG;AACnG;;IAEI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;IAEI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["@import url('./reset.css');\n@import url('./colors.css');\n@import url('https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Source+Serif+4:ital,opsz,wght@0,8..60,200..900;1,8..60,200..900&display=swap');\n\n:root,\n:host {\n    --space-2xs: 4px;\n    --space-xs: 8px;\n    --space-sm: 16px;\n    --space-md: 24px;\n    --space-lg: 32px;\n    --space-xl: 48px;\n    --space-2xl: 64px;\n    --space-3xl: 96px;\n    --touch-target-min: 48px;\n    --page-content-max-width: 1200px;\n\n    --radius-sm: 6px;\n    --radius-md: 10px;\n    --radius-lg: 16px;\n\n    --focus-outline-offset: 4px;\n    --focus-outline-offset-sm: 2px;\n}\n\nhtml {\n    font-size: 16px;\n}\n\nbody,\n:host {\n    background: var(--color-neutral-50);\n    color: var(--color-text-primary);\n    font-family: 'Hanken Grotesk', 'Open Sans', sans-serif;\n    font-size: 1rem;\n    font-weight: 400;\n}\n\np {\n    margin-top: 0;\n    margin-bottom: var(--space-sm);\n    line-height: 1.6;\n}\n\nh1 {\n    font-size: 38px;\n    font-weight: 700;\n    line-height: 1.15;\n    letter-spacing: -0.015em;\n    margin-top: 0;\n    margin-bottom: var(--space-md);\n}\n\nh2 {\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 1.2;\n    letter-spacing: -0.01em;\n    margin-top: 0;\n    margin-bottom: var(--space-sm);\n}\n\nh3 {\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 1.25;\n    letter-spacing: -0.005em;\n    margin-top: 0;\n    margin-bottom: var(--space-sm);\n}\n\nh4 {\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 1.3;\n    margin-top: 0;\n    margin-bottom: var(--space-xs);\n}\n\nh5 {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.35;\n    margin-top: 0;\n    margin-bottom: var(--space-xs);\n}\n\n.vec-text-display {\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n    margin-top: 0;\n    margin-bottom: var(--space-lg);\n}\n\n@media (min-width: 1280px) {\n    .vec-text-display {\n        font-size: 64px;\n    }\n}\n\n.vec-text-small {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.4;\n}\n\n.vec-text-caption {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 1.4;\n    letter-spacing: 0.01em;\n}\n\n.vec-text-label {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.4;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n\n/* Visually hides content while keeping it in the accessibility tree — e.g. a heading needed\n   for document structure/screen readers but not part of a page's visual design. */\n.vec-sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n\na {\n    color: var(--color-text-brand);\n    text-decoration: underline;\n}\n\na:focus-visible {\n    outline: 2px solid var(--color-focus-outline);\n    outline-offset: var(--focus-outline-offset);\n    border-radius: var(--radius-sm);\n}\n\n/* Plain HTML tables only — excludes anything rendered inside antd's Table (`.ant-table`),\n   which supplies its own styling and shouldn't be touched here. */\ntable:not(.ant-table table) {\n    width: 100%;\n    margin-bottom: var(--space-sm);\n    border-collapse: separate;\n    border-spacing: 0;\n    border: 1px solid var(--color-neutral-300);\n    border-radius: var(--radius-md);\n    overflow: hidden;\n}\n\ntable:not(.ant-table table) th,\ntable:not(.ant-table table) td {\n    padding: var(--space-xs) var(--space-sm);\n    text-align: left;\n    border-right: 1px solid var(--color-neutral-300);\n    border-bottom: 1px solid var(--color-neutral-300);\n}\n\ntable:not(.ant-table table) th:last-child,\ntable:not(.ant-table table) td:last-child {\n    border-right: none;\n}\n\ntable:not(.ant-table table) tr:last-child > td {\n    border-bottom: none;\n}\n\ntable:not(.ant-table table) th {\n    background: var(--color-surface-brand);\n    color: var(--color-text-on-brand);\n    font-weight: 600;\n}\n\n/* Plain lists only — excludes anything rendered inside an antd component (Menu, Pagination,\n   Rate, dropdown menus, etc. all render bare <ul>s of their own that shouldn't be touched here). */\nol:not([class*=\"ant-\"] ol),\nul:not([class*=\"ant-\"] ul) {\n    margin: 0 0 var(--space-sm);\n    padding-left: var(--space-md);\n}\n\nol:not([class*=\"ant-\"] ol) ol,\nul:not([class*=\"ant-\"] ul) ul {\n    margin-top: var(--space-2xs);\n    margin-bottom: 0;\n}\n\nol:not([class*=\"ant-\"] ol) li,\nul:not([class*=\"ant-\"] ul) li {\n    margin-bottom: var(--space-2xs);\n}\n\nol:not([class*=\"ant-\"] ol) {\n    list-style-type: decimal;\n}\n\nol:not([class*=\"ant-\"] ol) ol {\n    list-style-type: lower-alpha;\n}\n\nol:not([class*=\"ant-\"] ol) ol ol {\n    list-style-type: lower-roman;\n}\n\nol:not([class*=\"ant-\"] ol) li::marker {\n    font-weight: 700;\n}\n\nul:not([class*=\"ant-\"] ul) {\n    list-style-type: disc;\n}\n\nul:not([class*=\"ant-\"] ul) ul {\n    list-style-type: circle;\n}\n\nul:not([class*=\"ant-\"] ul) ul ul {\n    list-style-type: square;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
